export default __webpack_public_path__ + "static/media/mediosdepago.b59ce2bf.png";